import { Button as ButtonUI } from '../index'

const Button = ({ title, submittingText, isSubmitting, withDisable, ...el }: any) => {
  const disabledAttr = withDisable
    ? {
        disabled: !(el.isValid && el.dirty)
      }
    : {}

  return (
    <ButtonUI type="submit" {...disabledAttr}>{!isSubmitting ? title : submittingText}</ButtonUI>
  )
}

export default Button
